import React from "react";

const VehicleCard = ({ vehicle }) => (
  <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm flex flex-col">
    <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
      <h3 className="text-[12px] uppercase tracking-widest text-gray-500 font-semibold">
        Vehicle Assignment
      </h3>
    </div>
    <div className="p-6 flex-1 flex flex-col justify-center">
      {vehicle ? (
        <div className="flex items-center gap-5 p-5 bg-gray-50 rounded-xl border border-gray-200">
          <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center shadow-inner text-purple-700 text-3xl">
            🚗
          </div>
          <div>
            <p className="text-[16px] font-bold leading-tight">
              {[vehicle.make, vehicle.model].filter(Boolean).join(" ") || "—"}
            </p>
            <p className="text-[13px] font-medium text-gray-500 mt-1">
              Plate: <span className="text-purple-800 font-bold">{vehicle.plate || "—"}</span>
            </p>
            <div className="mt-2 flex items-center gap-2">
              <span className={`w-2 h-2 rounded-full ${vehicle.status === "Active" ? "bg-green-600" : "bg-gray-400"}`} />
              <span className="text-[11px] font-bold text-gray-500 uppercase tracking-tight">
                {vehicle.status || "Unknown"}
              </span>
            </div>
          </div>
        </div>
      ) : (
        <div className="text-sm text-gray-500 italic text-center">
          No vehicle assigned.
        </div>
      )}
    </div>
  </div>
);

export default VehicleCard;
